var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { useCallback, useMemo } from 'react';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import TransferComponent from 'app/components/transferModule/content/transfer/TransferComponent';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import splitArrayIntoChunks from 'app/components/swipeableViews/splitArrayIntoChunks';
import { View } from 'app/components/transferModule/content/commonStyles';
const Filler = styled.div.withConfig({
  componentId: "sc-c19myd-0"
})(["height:", ";width:100%;", ""], SIZES['56'], props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-width: 477px;\n  "]))));
const VerticalLine = styled.div.withConfig({
  componentId: "sc-c19myd-1"
})(["display:none;", ""], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    width: 1px;\n    background-color: ", ";\n    position: absolute;\n    top: ", ";\n    left: 50%;\n    bottom: ", ";\n  "])), COLORS.lightGrey, SIZES['16'], SIZES['24']));
export default function TransferList(_ref) {
  let {
    transfers,
    transfersPerView
  } = _ref;
  const viewData = useMemo(() => {
    return splitArrayIntoChunks(transfers, transfersPerView, true);
  }, [transfers, transfersPerView]);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    return /*#__PURE__*/React.createElement(View, {
      key: "transfer-view-".concat(transfersPerView, "-").concat(index)
    }, viewData[index].map((transfer, elementIndex) => {
      if (!transfer) {
        return /*#__PURE__*/React.createElement(Filler, {
          key: "transfer-filler-".concat(transfersPerView, "-").concat(elementIndex)
        });
      }
      return /*#__PURE__*/React.createElement(TransferComponent, {
        key: "".concat(transfersPerView, "-").concat(transfer.getKey()),
        transfer: transfer
      });
    }), /*#__PURE__*/React.createElement(VerticalLine, null));
  }, [transfersPerView, viewData]);
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    stepCount: viewData.length,
    hideStepperWithoutPages: true,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "TransferList",
    "data-sentry-source-file": "TransferList.tsx"
  });
}